export const crmTelemarketingArticle = {
  title: 'Customer CRM: Telemarketing',
  slug: 'crm-telemarketing',
  content: `Customer CRM: Telemarketing

The Telemarketing tab is where you launch AI-assisted call campaigns.

1) Open Telemarketing
- From /crm, select the Telemarketing tab.
- You can also visit /crm/telemarketing directly.

2) Create a campaign
- Choose a goal (for example, book meetings).
- Upload or paste your target list when prompted.

3) Monitor campaign activity
- Track campaign status and follow-ups inside the Telemarketing workspace.
- Review outcomes to see which prospects need manual attention.
`,
};
